import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl, tablet_s } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween } from '../../../global/commonStyle';

const ModalDiv = styled.div`
  display: flex;
  flex-direction: column;
  ${tablet_s(css`
    max-width: 100%;
  `)}
`;

const HeadingSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
`;

const ButtonDiv = styled.div`
  ${FlexBetween}
  gap: var(--space-12);
  padding: var(--space-16);
  box-shadow: var(--top-border);
`;
const Div = styled.div`
  display: flex;
  ${mobile_xl(css`
    flex-direction: column;
  `)}
`;
const LeftDiv = styled.div`
  padding: var(--space-16);
  border-right: 0.5px solid var(--border-primary);
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
  max-width: 265px;
  width: 100%;
  ${mobile_xl(css`
    box-shadow: var(--bottom-border);
    border-right: none;
    max-width: -webkit-fill-available;
  `)}
`;

const RightDiv = styled.div`
  margin-block: var(--space-5);
  max-width: 376px;
  width: 100%;
  padding: var(--space-16);
  display: flex;
  flex-direction: column;
  gap: var(--space-18);
  ${mobile_xl(css`
    max-width: -webkit-fill-available;
    gap: var(--space-16);
  `)}
`;
const Icon = styled.div`
  background-color: var(--brand-primary);
  border-radius: var(--border-radius-full);
  width: max-content;
  padding: var(--space-6);
  display: flex;
  align-items: center;
  justify-content: center;
  ${mobile_xl(css`
    padding: var(--space-8);
  `)}
`;
const Heading = styled.h2`
  ${Typography.heading_md}
  color: var(--text-primary);
  margin: var(--space-0);
`;
const Detail = styled.h2`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  margin: var(--space-0);
  ${mobile_xl(css`
    margin-top: -6px;
  `)}
`;
const Title = styled.h2`
  ${Typography.heading_md}
  color: var(--text-primary);
  margin: var(--space-0);
`;
const Features = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: var(--space-20);
  ${mobile_xl(css`
    grid-column-gap: var(--space-12);
  `)}
`;
const FeatureDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
`;
const SubDiv = styled.div`
  display: flex;
  gap: var(--space-8);
  align-items: flex-start;
  white-space: nowrap;
  p {
    ${Typography.body_md}
    color: var(--text-primary);
    margin: var(--space-0);
  }
  ${mobile_xl(css`
    white-space: normal;
  `)}
`;
const Icons = styled.div`
  display: flex;
  width: 16px;
  height: 16px;
  .fill-color {
    padding-top: var(--space-3);
    width: 16px;
    height: 16px;
    path {
      fill: var(--text-primary);
    }
  }
`;
const ProgressDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
`;
const ProgressText = styled.div`
  ${Typography.body_md}
  color: var(--text-secondary);
  span {
    color: var(--brand-primary);
  }
`;

const ButtonWrapper = styled.div`
  ${AlignCenter}
  gap: var(--space-12);
`;
export {
  ModalDiv,
  ButtonDiv,
  Div,
  LeftDiv,
  RightDiv,
  Icon,
  Heading,
  Detail,
  Title,
  FeatureDiv,
  SubDiv,
  Icons,
  ProgressDiv,
  ProgressText,
  Features,
  ButtonWrapper,
  HeadingSection
};
